import { createContext, useContext, useReducer, useMemo, useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";

// Material Dashboard 2 React main context
const MaterialUI = createContext();

// authentication context
export const AuthContext = createContext({
  isAuthenticated: false,
  login: () => { },
  register: () => { },
  logout: () => { },
  userRole: () => { },
  iscenterAdmin: () => { },
});

const AuthContextProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const tokens = localStorage.getItem('authToken');
  const userData = localStorage.getItem('user');
  const [loading, setLoading] = useState(true);
  const [authToken, setAuthTokens] = useState(() => {
    return tokens ? JSON.parse(tokens) : null;
  });
  const [user, setUser] = useState(() => {
    try {
      const userData = localStorage.getItem('user');
      return userData ? JSON.parse(userData) : null;  // Fallback to null if parsing fails
    } catch (error) {
      console.error("Error parsing user data from localStorage", error);
      return null;  // Return null in case of error
    }
  });




  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return tokens ? true : false;
  });

  const navigate = useNavigate();
  const location = useLocation();


useEffect(() => {
  const currentPath = location.pathname;

  if (currentPath.startsWith("/auth")) return;

  if (
    currentPath.startsWith("/karkuns/device-verify") ||
    currentPath.startsWith("/attendance/karkun-attendance-verify")
  ) {
    return;
  }

  // 🚫 If user not authenticated → redirect to login
  if (!authToken) {
    navigate("/auth/login");
    return;
  }

  setIsAuthenticated(true);
}, [authToken, location.pathname]);





  useEffect(() => {
    console.log("Tokens", tokens);
    console.log("User", user);
  }, [tokens, user]);

  useEffect(() => {
    console.log("User State Updated:", user);
  }, [user]);

  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      try {
        const parsedToken = JSON.parse(storedToken);
        const parsedUser = JSON.parse(storedUser);
        setAuthTokens(parsedToken);
        setUser(parsedUser);
        setIsAuthenticated(true);
      } catch (err) {
        console.error("Error parsing token/user", err);
        logout(); // fallback
      }
    } else {
      logout(); // No data in localStorage
    }
  }, []);


 useEffect(() => {
  const currentPath = location.pathname;
  console.log("🔍 Current Path:", currentPath);
  console.log("🔑 Tokens:", tokens);

  // ✅ Allow all auth routes
  if (currentPath.startsWith("/auth")) return;

  // ✅ Allow public verification routes
  if (
    currentPath.includes("/karkuns/device-verify") ||
    currentPath.includes("/attendance/karkun-attendance-verify")
  ) {
    console.log("✅ Public route detected, skipping login redirect");
    return;
  }

  // 🚫 If user not authenticated → redirect to login
  if (!tokens) {
    console.warn("🚫 No token found, redirecting to /auth/login");
    navigate("/auth/login");
    return;
  }

  setIsAuthenticated(isAuthenticated);
}, [isAuthenticated, location.pathname]);


  const login = async (authData) => {
    try {
      const { user, token, } = authData;
      console.log('authData', authData);

      // Save tokens and user to localStorage
      localStorage.setItem('authToken', JSON.stringify(token));
      localStorage.setItem('user', JSON.stringify(user));

      // Update state
      setAuthTokens(authData.token);
      setUser(authData.user);
      setIsAuthenticated(true);
      setError(null);

      navigate("/dashboard");
    } catch (err) {
      console.log('Error:', err);
      setError(err.message);
    }
  };


  const register = async (userData) => {
    try {
      const response = await fakeRegisterApi(userData);
      const { user, accessToken, refreshToken } = response;

      const tokens = { accessToken, refreshToken };
      localStorage.setItem('authToken', JSON.stringify(tokens));
      setAuthTokens(tokens);
      setUser(user);
      setIsAuthenticated(true);
      setError(null);
    } catch (err) {
      setError(err.message);
    }
  };

  const logout = async () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setAuthTokens(null);
    setUser(null);
    setIsAuthenticated(false);
    setError(null);
  };

  const isAdmin = () => {
    return user && user.role === "admin";
  }

  const iscenterAdmin = () => {
    return user && user.role === "centeradmin";
  }

  const userRole = () => {
    return user?.role;
  }

  const refreshAccessToken = async () => {
    if (!authToken) return;
    try {
      const response = await fakeRefreshTokenApi(authToken.refreshToken);
      const newTokens = { ...authToken, accessToken: response.accessToken };

      localStorage.setItem('authToken', JSON.stringify(newTokens));
      setAuthTokens(newTokens);
    } catch (err) {
      console.error('Failed to refresh access token:', err.message);
      logout(); // Logout if refreshing fails
    }
  };
  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, register, logout, isAdmin, iscenterAdmin, userRole, error, setError }}>
      {children}
    </AuthContext.Provider>
  );
};

MaterialUI.displayName = "MaterialUIContext";

// Material Dashboard 2 React reducer
function reducer(state, action) {
  switch (action.type) {
    case "MINI_SIDENAV": {
      return { ...state, miniSidenav: action.value };
    }
    case "TRANSPARENT_SIDENAV": {
      return { ...state, transparentSidenav: action.value };
    }
    case "WHITE_SIDENAV": {
      return { ...state, whiteSidenav: action.value };
    }
    case "SIDENAV_COLOR": {
      return { ...state, sidenavColor: action.value };
    }
    case "TRANSPARENT_NAVBAR": {
      return { ...state, transparentNavbar: action.value };
    }
    case "FIXED_NAVBAR": {
      return { ...state, fixedNavbar: action.value };
    }
    case "OPEN_CONFIGURATOR": {
      return { ...state, openConfigurator: action.value };
    }
    case "DIRECTION": {
      return { ...state, direction: action.value };
    }
    case "LAYOUT": {
      return { ...state, layout: action.value };
    }
    case "DARKMODE": {
      return { ...state, darkMode: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function MaterialUIControllerProvider({ children }) {
  const initialState = {
    miniSidenav: false,
    transparentSidenav: false,
    whiteSidenav: false,
    sidenavColor: "info",
    transparentNavbar: true,
    fixedNavbar: true,
    openConfigurator: false,
    direction: "ltr",
    layout: "dashboard",
    darkMode: false,
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return <MaterialUI.Provider value={value}>{children}</MaterialUI.Provider>;
}

// Material Dashboard 2 React custom hook for using context
function useMaterialUIController() {
  const context = useContext(MaterialUI);

  if (!context) {
    throw new Error(
      "useMaterialUIController should be used inside the MaterialUIControllerProvider."
    );
  }

  return context;
}

// Typechecking props for the MaterialUIControllerProvider
MaterialUIControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Context module functions
const setMiniSidenav = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
const setTransparentSidenav = (dispatch, value) => dispatch({ type: "TRANSPARENT_SIDENAV", value });
const setWhiteSidenav = (dispatch, value) => dispatch({ type: "WHITE_SIDENAV", value });
const setSidenavColor = (dispatch, value) => dispatch({ type: "SIDENAV_COLOR", value });
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setOpenConfigurator = (dispatch, value) => dispatch({ type: "OPEN_CONFIGURATOR", value });
const setDirection = (dispatch, value) => dispatch({ type: "DIRECTION", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
const setDarkMode = (dispatch, value) => dispatch({ type: "DARKMODE", value });

export {
  AuthContextProvider,
  MaterialUIControllerProvider,
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  setSidenavColor,
  setTransparentNavbar,
  setFixedNavbar,
  setOpenConfigurator,
  setDirection,
  setLayout,
  setDarkMode,
};
